export const SET_CURRENT_USER   = "SET_CURRENT_USER";
export const LOGOUT             = "LOGOUT";
export const REGISTER_SUCCESS   = 'REGISTER_SUCCESS';
export const GET_ERRORS         = 'GET_ERRORS';
